import axiosInstance from './axiosInstance';

export async function createVehicle(vehicleData) {
  const response = await axiosInstance.post('/vehicles/create-vehicle.php', vehicleData);
  return response.data;
}




export async function getVehicleDetail(id) {
  const response = await axiosInstance.get(`/vehicles/get-vehicle-detail.php?id=${id}`);
  return response.data;
}

export async function editVehicle(vehicleData) {
  const response = await axiosInstance.post('/vehicles/edit-vehicle.php', vehicleData);
  return response.data;
}

export async function unassignVehicle(vehicleId) {
  const response = await axiosInstance.post('/vehicles/unassign-vehicle.php', { id_vehicle: vehicleId });
  return response.data;
}